interface CardQueryObj {
  drug?: string;
  slug?: string;
  form?: string;
  strength?: string;
  strengthLabel?: string;
  quantity?: string;
  quantityLabel?: string;
  zip?: string;
  chainCode?: string;
  chainLabel?: string;
  npi?: string;
  lang?: string;
}

export const decodeCardQuery = (query: string): CardQueryObj => {
  try {
    let json;

    if (typeof atob !== 'undefined') {
      json = JSON.parse(atob(query));
    } else {
      json = JSON.parse(Buffer.from(query || '', 'base64').toString('ascii'));
    }

    const ret: CardQueryObj = {
      drug: json.n,
      slug: json.s,
      form: JSON.parse(json.f),
      strength: json.d,
      strengthLabel: json.dl,
      quantity: json.q,
      quantityLabel: json.ql,
    };

    if (json.z) ret.zip = json.z;
    if (json.c) ret.chainCode = json.c;
    if (json.cl) ret.chainLabel = json.cl;
    if (json.i) ret.npi = json.i;

    return ret;
  } catch {
    return {};
  }
};

export const encodeCardQuery = (query: CardQueryObj = {}): string | null => {
  const { drug, slug, form, strength, strengthLabel, quantity, quantityLabel, zip, chainCode, chainLabel, npi } = query;
  const queryStr = JSON.stringify({
    n: drug,
    s: slug,
    f: form,
    d: strength,
    dl: strengthLabel,
    q: quantity,
    ql: quantityLabel,
    z: zip,
    c: chainCode,
    cl: chainLabel,
    i: npi,
  });

  if (typeof btoa !== 'undefined') {
    return btoa(queryStr);
  }

  return Buffer.from(queryStr).toString('base64');
};

export const validateCardQuery = (query: CardQueryObj): boolean => {
  const { drug, slug, form, strength, quantity } = query;
  return !!(drug && slug && form && strength && quantity);
};

export const getPage = (values: CardQueryObj): string => {
  let queryString = '';
  if (values.npi) queryString = `&your-pharmacy`;
  else if (values.chainLabel || values.chainCode) queryString = `&no-location`;
  return queryString;
};

export const getURL = (values: CardQueryObj): string => {
  const langRouteParam = values.lang === 'es' ? '/es' : '';
  return `${langRouteParam}/savings-card?d=${encodeCardQuery(values)}${getPage(values)}`;
};
